<template>
  <div>
    <Header/>
    <div class="container bg-white p-5">
      <div v-for="article in displayArticle" :key="article.index">
        <span class="text-10 text-gray">
          <i class="fas fa-calendar-week"></i>
          {{moment(article.created_at).locale('th').format('lll')}}
        </span>
        <h4>{{article.article_name}}</h4>
        <img :src="getImgNewArticle(article.path_file)" class="img-fluid">
        <hr>
        <span v-html="text(article.article_detail)"></span>
        <br>
        <span class="text-10 text-gray">
          <b>
            <i class="fas fa-globe"></i> ที่มา:
          </b>
          <a
            :href="refLink(article.ref_link)"
            target="_blank"
            rel="noopener noreferrer"
          >{{article.ref_name}}</a>
        </span>
        <hr>
        <div class="d-flex justify-content-between mt-4">
          <div>
            <h5>โพสต์ล่าสุด</h5>
          </div>
          <div class="text-right">
            <router-link to="/article">ดูทั้งหมด</router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 bordered mb-3" v-for="article in articles" :key="article.index">
          <div class="card mb-5 mb-lg-0" data-aos="zoom-in" :title="titleText(article.article_name)">
            <img :src="getImgNewArticle(article.path_file)" class="card-img-top">
            <div class="article-caption bg-light p-2 w-100">
              <a :href="linkNewArticle(article.article_id)" @click="linkId(article.article_id)">
                <i class="fas fa-scroll text-danger"></i>
                {{subText(article.article_name)}}
              </a>
              <br>
              <span class="text-gray text-10">
                <i class="fas fa-clock"></i>
                {{moment(article.created_at).locale('th').format('lll')}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>
      <br>
    </div>
    <Footer/>
  </div>
</template>

<style scoped>
.router-link-exact-active {
  background-color: #ffffff;
  color: rgb(0, 0, 0) !important;
  border-bottom: 5px solid #ffffff;
}
</style>

<script>
var moment = require("moment");
import Header from "../components/Header";
import Footer from "../components/Footer";
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      articles: {},
      moment: moment,
      displayArticle: {}
    };
  },
  methods: {
    refLink(link) {
      let url = link;
      return url;
    },
    showArticle() {
      this.axios
        .post("http://pgm01.toonjob.com/2019/BannKlong/project/showArticle", {
          id: this.$route.params.id
        })
        .then(response => {
          this.displayArticle = response.data;
        });
    },
    listArticle() {
      this.axios
        .get("http://pgm01.toonjob.com/2019/BannKlong/project/threeArticle")
        .then(response => {
          this.articles = response.data;
        });
    },
    getImgNewArticle(img) {
      let image = "http://pgm01.toonjob.com/2019/BannKlong/image/articles/" + img;
      return image;
    },
    linkNewArticle(id) {
      let link = "/articleDetail/" + id;
      return link;
    },
    text(text) {
      let message = text;
      return message;
    },
    subText(text) {
      let message = text.substring(0, 35) + "...";
      return message;
    },
    titleText(text) {
      let message = text;
      return message;
    },
    linkId(id){
      window.location.href = "/articleDetail/" + id;
      this.showArticle()
      window.scrollTo(0,0);
    }
  },
  created() {
    this.$Progress.start();
    this.listArticle();
    this.showArticle();
    this.$Progress.finish();
  }
};
</script>


// WEBPACK FOOTER //
// src/frontEnd/AritcleDetail.vue